var _path, _path2, _circle, _path3, _path4, _path5, _path6, _path7, _path8, _circle2, _path9, _path0, _path1, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSteps3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    height: 64,
    width: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#929AA5",
    d: "M23.697 58.666c-3.111-.009-6.685-1.245-10.363-4.922V34.666h15.8l9.66 9.66a6.174 6.174 0 01-8.732 0l-4.129-4.129-1.345 1.346 6.403 6.473h19.677c0 5.878-4.765 10.643-10.643 10.643l-16.174.008h-.154z",
    clipRule: "evenodd",
    fillRule: "evenodd",
    opacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#AEB4BC",
    d: "M5.334 34.666h8v24h-8v-24z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#687EE3",
    r: 9.333,
    cy: 32.027,
    cx: 46.666
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D8EC",
    d: "M46.666 35.327v3.25l4.001-5.617-4 2.367z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#C4C8D8",
    d: "M46.666 30.311v4.185l4.001-2.367-4-1.817z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#D0D6EA",
    d: "M46.666 25.494v4.817l4.001 1.817-4-6.634z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#DEE2F6",
    d: "M46.666 35.327v3.25l-4-5.617 4 2.367z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D8EC",
    d: "M46.666 30.311v4.185l-4-2.367 4-1.817z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#DEE2F6",
    d: "M46.666 25.494v4.817l-4 1.817 4-6.634z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    fill: "#687EE3",
    r: 8,
    cy: 18.707,
    cx: 29.306
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D8EC",
    d: "M29.306 21.536v2.787l3.43-4.816-3.43 2.03z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#C4C8D8",
    d: "M29.306 17.237v3.586l3.43-2.029-3.43-1.557z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#D0D6EA",
    d: "M29.306 13.107v4.13l3.43 1.557-3.43-5.687z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#DEE2F6",
    d: "M29.307 21.536v2.787l-3.43-4.816 3.43 2.03z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#D2D8EC",
    d: "M29.307 17.237v3.586l-3.43-2.029 3.43-1.557z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#DEE2F6",
    d: "M29.307 13.107v4.13l-3.43 1.557 3.43-5.687z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSteps3);
export default __webpack_public_path__ + "static/media/steps_3.a36e6669993356349ab0a483424f3c73.svg";
export { ForwardRef as ReactComponent };